import React from 'react'

import { Button, EnumButtonVariants } from '@insquad/tools'

import { StarIcon } from 'src/common/components/icons/StarIcon'
import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'
import { Resume } from 'src/graphql/types'

import { CandidateCardBadgesList } from './_components/CandidateCardBadgesList/CandidateCardBadgesList'
import { CandidateCardHeader } from './_components/CandidateCardHeader/CandidateCardHeader'
import { CandidateCardInfo } from './_components/CandidateCardInfo/CandidateCardInfo'

import s from './ResumeCard.module.scss'

export interface IResumeCardProps extends Resume {
  onViewProfile: () => void
}

export const ResumeCard: React.FC<IResumeCardProps> = ({
  firstName,
  summary,
  specialization,
  photo,
  totalExperience,
  Languages,
  Technologies,
  onViewProfile,
}) => (
  <div className={s.ResumeCard}>
    <Typography
      className={s.ResumeCard__badge}
      variant={EnumTypographyVariants.CAPTION}
    >
      <div className={s.ResumeCard__badgeIcon}>
        <StarIcon />
      </div>
      Perfect match
    </Typography>

    <CandidateCardHeader
      name={firstName || ''}
      role={specialization}
      avatarSrc={photo}
    />

    <CandidateCardInfo
      availability="Ready to start now"
      summary={summary}
      totalExperience={totalExperience}
    />

    {!!Languages?.length && (
      <CandidateCardBadgesList
        title="Languages"
        marginTop="md"
        badges={Languages}
      />
    )}

    {!!Technologies?.length && (
      <CandidateCardBadgesList
        title="Technologies"
        marginTop="sm"
        badges={Technologies}
      />
    )}

    <div className={s.ResumeCard__btnWrapper}>
      <Button
        variant={EnumButtonVariants.SECONDARY}
        className={s.ResumeCard__btn}
        onClick={onViewProfile}
      >
        View profile
      </Button>
    </div>
  </div>
)
